<template>
  <div class="questionContainer">
    <div v-if="teskDetail.available === true">
      <div class="questionContent">
        <div class="questionTitle" v-for="(item, key) in teskDetail.subject" :key="key">
          <div class="questionName" v-if="item.type === 'TEXT'">
            <span class="position">{{ teskDetail.position }}</span><span class="total">/{{ teskDetail.total }}</span>
            <span v-for="(text, key) in item.values" :key="key"><span class="questionTypeName">{{ teskDetail.questionTypeName }}</span> {{ text }}</span>
          </div>
          <div class="questionName htmlBox" v-if="item.type === 'HTML' && item.values[0]">
            <span class="position">{{ teskDetail.position }}</span><span class="total">/{{ teskDetail.total }}</span>
            <span class="questionTypeName">{{ item.questionTypeName }}</span>
            <span v-for="(ht, key) in item.values" :key="key"><span v-html="ht"></span></span>
          </div>
          <ul class="imgList" v-else-if="item.type === 'IMAGE'">
            <li v-for="(img, key) in item.values" :key="key">
              <img :src="img" alt="">
            </li>
          </ul>
        </div>
        <!-- 单选题 -->
        <ul class="radioList" v-if="showSeleted">
          <li>
            <div v-for="(item, key) in optionList['A']" :key="key">
              <div class="option-item" v-if="item.type === 'TEXT'">
                <div class="options">
                  <div class="radio">A</div>
                  <div class="text-overflow">{{ item['values'][0] }}</div>
                </div>
              </div>
              <div class="option-item" v-if="item.type === 'HTML'">
                <div class="options">
                  <div class="radio">A</div>
                  <div class="text-overflow" v-for="(ht, key) in item.values" :key="key" ><span v-html="ht"></span></div>
                </div>
              </div>
              <ul class="optionImg" v-else-if="item.type === 'IMAGE'">
                <li v-for="(img, key) in item.values" :key="key">
                  <img :src="img" alt="">
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div v-for="(item, key) in optionList['B']" :key="key">
              <div class="option-item" v-if="item.type === 'TEXT'">
                <div class="options">
                  <div class="radio">B</div>
                  <div class="text-overflow">{{ item['values'][0] }}</div>
                </div>
              </div>
              <div class="option-item" v-if="item.type === 'HTML'">
                <div class="options">
                  <div class="radio">B</div>
                  <div class="text-overflow" v-for="(ht, key) in item.values" :key="key" ><span v-html="ht"></span></div>
                </div>
              </div>
              <ul class="optionImg" v-else-if="item.type === 'IMAGE'">
                <li v-for="(img, key) in item.values" :key="key">
                  <img :src="img" alt="">
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div v-for="(item, key) in optionList['C']" :key="key">
              <div class="option-item" v-if="item.type === 'TEXT'">
                <div class="options">
                  <div class="radio">C</div>
                  <div class="text-overflow">{{ item['values'][0] }}</div>
                </div>
              </div>
              <div class="option-item" v-if="item.type === 'HTML'">
                <div class="options">
                  <div class="radio">C</div>
                  <div class="text-overflow" v-for="(ht, key) in item.values" :key="key" ><span v-html="ht"></span></div>
                </div>
              </div>
              <ul class="optionImg" v-else-if="item.type === 'IMAGE'">
                <li v-for="(img, key) in item.values" :key="key">
                  <img :src="img" alt="">
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div v-for="(item, key) in optionList['D']" :key="key">
              <div class="option-item" v-if="item.type === 'TEXT'">
                <div class="options">
                  <div class="radio">D</div>
                  <div class="text-overflow">{{ item['values'][0] }}</div>
                </div>
              </div>
              <div class="option-item" v-if="item.type === 'HTML'">
                <div class="options">
                  <div class="radio">D</div>
                  <div class="text-overflow" v-for="(ht, key) in item.values" :key="key" ><span v-html="ht"></span></div>
                </div>
              </div>
              <ul class="optionImg" v-else-if="item.type === 'IMAGE'">
                <li v-for="(img, key) in item.values" :key="key">
                  <img :src="img" alt="">
                </li>
              </ul>
            </div>
          </li>
        </ul>

      </div>
      <!-- 主观题解答 -->
      <div class="textareaBox" v-if="!showSeleted">
        <van-cell-group inset>
          <van-field
            v-model="message"
            rows="1"
            :autosize="{minHeight: minHeight}"
            type="textarea"
            placeholder="请输入答题内容"
          />
        </van-cell-group>
      </div>
    </div>
    <div class="questionImg" v-else>
      <img src="@/assets/icon/question/none_exe.png" alt="">
      <p>今日没有专题练习</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { getHome } from '@/api/exercise'
import utils from "../../../public/utils"

export default defineComponent({
  data() {
    return {
      teskDetail: {},
      optionList: {},
      message: '',
      showSeleted: '',
      minHeight: 100,
      imgShow: false,
      loaded: false
    }
  },
  methods: {
    getHome() {
      getHome({
        userId: utils.getUserId()
      }
      ).then(res => {
        this.loaded = true;
        if (Number(res.code) === 200) {
          this.teskDetail = res.data
          if (this.teskDetail.exerciseId) {
            if (utils.isApp()) {
              utils.setExerciseId(String(this.teskDetail.exerciseId))
            }
          }
          if (this.teskDetail.available === true) {
            this.optionList = res.data.options
            this.imgShow = false
            switch (this.teskDetail.questionType) {
              case 'BOOLEAN':
                this.showSeleted = true
                break
              case 'SINGLE':
                this.showSeleted = true
                break
              case 'MULTIPLE':
                this.showSeleted = true
                break
              case 'OPINION':
                this.showSeleted = true
                break
              default:
                break
            }
          } else {
            this.imgShow = true
          }
        } else {
          // this.$toast(res.message)
        }
      })
    }
  },
  mounted() {
    this.minHeight = 2.8 * Number(localStorage.getItem('rem'))
    this.getHome()
  }
})
</script>
<style lang="scss">
.htmlBox {
  > div {
    display: inline;
    p:first-child {
      display: inline;
      strong{
        font-weight: 500;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
  .questionContainer {
    width: 750px;
    margin: 0 auto;
    padding: 0 32px 24px;
    box-sizing: border-box;
    .questionName {
      min-height: 56px;
      line-height: 56px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
    .questionTypeName {
      font-size: 32px;
      font-family: Helvetica;
      color: #FF6600;
      line-height: 56px;
    }
    .position, .total {
      font-size: 40px;
      font-family: DINEngschrift;
      color: #FF6600;
    }
    .total {
      color: rgba(255, 102, 0, 0.5);
    }
    .questionTitle {
      max-height: 192px;
      padding-top: 20px;
      overflow: hidden;
    }
    .imgList {
      li {
        overflow: hidden;
      }
    }
    .option-item {
      width: 500px;
      min-height: 72px;
      background: #F5F5F7;
      border-radius: 36px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      align-items: center;
      padding: 16px 20px 16px 44px;
      font-size: 32px;
      margin-top: 40px;
    }
    .options {
      height: 40px;
      display: flex;
      align-items: center;
      padding-right: 10px;
      overflow: hidden;
      flex: 1;
      line-height: 1;
      .text-overflow {
        flex: 1;
      }
    }
    .optionImg {
      padding-top: 40px;
    }
    .radioList , .checkboxList {
      overflow: hidden;
      li {
        min-height: 104px;
        font-size: 28px;
        .radio {
          text-align: center;
          margin-right: 24px;
          color: #B1B1B3;
        }
        .result {
          min-width: 28px;
          height: 28px;
          display: none;
          overflow: hidden;
          img {
            display: none;
          }
        }
      }
    }
    .judgeList {
      .radio {
        margin-right: 24px;
        .checked-icon {
          display: none;
        }
      }
      .result {
        display: none;
      }
      .checked {
        .radio {
          .checked-icon {
            display: block;
          }
          .unchecked-icon {
            display: none;
          }
        }
      }
      .rightOption {
        .result {
          display: block;
          .checkRight {
            display: block;
          }
          .checkWrong {
            display: none;
          }
        }
      }
      .wrongOption {
        .result {
          display: block;
          .checkWrong {
            display: block;
          }
          .checkRight {
            display: none;
          }
        }
      }
    }
    .questionImg{
      display:flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img{
        width: 282px;
      }
      p{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #969799;
        line-height: 34px;
      }
    }
  }
  .textareaBox {
    margin-top: 24px;
    height: 294px;
    border: 1Px solid #E1E2E6;
    box-sizing: border-box;
    overflow: hidden;
  }
</style>
